import { fontScale } from "utils";
import Div from "./Div";
import React from "react";
import { Efonts } from "constants/themes";
import { StyleProp, ViewStyle } from "react-native";

const RenderHtmlView = ({
  content = "",
  style = {},
  fontSize = 16
}: {
  content: string;
  style?: StyleProp<ViewStyle>;
  fontSize?: number;
}) => {
  return (
    <Div style={style}>
      <style>
        {`
            .html-content p {
                font-weight: 600; /* In đậm đầu câu */
                color: #30363D;
            }
   
            .html-content em {
                font-weight: 400; /* phần em không đậm */
                font-style: italic;
                color: #000
            }
        `}
      </style>

      <div
        className="html-content"
        style={{
          fontFamily: "system-ui",
          fontSize: fontScale(fontSize),
        }}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </Div>
  );
};

export default RenderHtmlView;
